import React from "react";
import { Box } from "./style";

export default props => {
  const { color, size } = props;
  return (
    <Box color={color} size={size}>
      <span>{props.children}</span>
    </Box>
  );
};
